/**
 * Vuex module for contact import form
 */
import debug from 'debug'

const dbg = debug('store:contacts:importForm:')

const actions = {
  open ({ commit }) {
    dbg('Open delete form dialog')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_DIALOG')
  },
  close ({ commit }) {
    dbg('Close delete form dialog')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_DIALOG')
  }
}

const mutations = {
  CLOSE_DIALOG (state) {
    state.dialog = false
  },

  OPEN_DIALOG (state) {
    state.dialog = true
  }
}

const state = {
  dialog: false
}

const getters = {
  dialog: state => state.dialog
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
